import React from "react";
import HeaderContent from "./HeaderContent";

const Header = () => {
  return <HeaderContent />;
};

export default Header;
